const state = () => {
    let persisted = JSON.parse(sessionStorage.getItem('login'));
    return persisted || {
        id_usuario: null,
        nome_usuario: null,
        razao_social: null,
        id_perfil_usuario: null,
        perfil_usuario: null,
        acc: null
    };
};

const getters = {
    id: (state) => {
        return state.id_usuario;
    },
    nome: (state) => {
        return state.nome_usuario;
    },
    empresa: (state) => {
        return state.razao_social;
    },
    idPerfil: (state) => {
        return state.id_perfil_usuario;
    },
    perfil: (state) => {
        return state.perfil_usuario;
    },
    super: (state) => {
        return state.perfil_usuario === 'Superadmin';
    },
    acc: (state) => {
        return state.acc;
    },
}

const mutations = {
    setUser(state, user) {
        state.id_usuario = user.id_usuario;
        state.nome_usuario = user.nome_usuario;
        state.razao_social = user.razao_social;
        state.id_perfil_usuario = user.id_perfil_usuario;
        state.perfil_usuario = user.perfil_usuario;
        state.acc = user.acc;
        sessionStorage.setItem('login', JSON.stringify(state));
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations
}